import { FaCalendarDays } from "react-icons/fa6"


import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";

import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import { toast } from "react-toastify";

import Tippy from 'tippy.js';

import { BACKEND } from "../config/configEnvs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import axios from "axios";
import SearchIcon from '@mui/icons-material/Search';
import { BackgroundColorQuotesStatusHex, GetStatusColor, TextColorQuotesStatus } from "../utils/GetTextColor";
import FilterSeguimientoClienteDialog from "../../src/components/dialogs/FilterSeguimientoClienteDialog"
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import { CapitalizeEachWord } from "../utils/CapitalizeLetters";
import { MdClose } from "react-icons/md";
import { Button } from "@mui/material";
import { FaTimes } from "react-icons/fa";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import { useSelector } from "react-redux";


export const CalendarioCotizaciones = () => {

  const user = useSelector((state) => state.auth.user);
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE"

  const getStartAndEndOfMonth = () => { // Obtner el inico y el fin del mes actual
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // Primer día del mes
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Último día del mes
  
    return {
      start: firstDay.toISOString().split("T")[0], // Formato YYYY-MM-DD
      end: lastDay.toISOString().split("T")[0],
    };
  };

  const { start, end } = getStartAndEndOfMonth();

  const [openDrawer, setOpenDrawer] = useState(false)
  const [openClienteDialog, setOpenClienteDialog] = useState(false)

  const [currentCot, setCurrentCot] = useState({})

  const [loading, setLoading] = useState(false)

  const [isMobile, setIsMobile] = useState(false);

  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [estado, setEstado] = useState("")
  const [subEstado, setSubEstado] = useState("")
  const [vendedor, setVendedor] = useState("")
  const [cliente, setCliente] = useState("")

  const [filterSelector, setFilterSelector] = useState("createdAt")

  const [paises, setPaises] = useState([])
  const [currencyExchanges, setCurrencyExchanges] = useState({})

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setPaises(response.data.docs);
    } catch (error) {
      console.error(error);
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }
  
  const [lead, setLead] = useState("")
  const [leadValue, setLeadValue] = useState("leadName")

  const [record, setRecord] = useState([])
  const [sellers, setSellers] = useState([])

  const totalExito = record.filter((e) => e.estado === "Exito").reduce((acum, e) => {
    return acum + (e.precioTotal || 0)
  }, 0)

  const totalEspera = record.filter((e) => e.estado === "En espera").reduce((acum, e) => {
    return acum + (e.precioTotal || 0)
  }, 0)

  const totalPerdido = record.filter((e) => e.estado === "Perdido").reduce((acum, e) => {
    return acum + (e.precioTotal || 0)
  }, 0)

  const resetFilters = () => {
    setStartDate(null)
    setEndDate(null)

    setEstado("")
    setVendedor("")
    setCliente("")
    setSubEstado("")

    setFilterSelector("createdAt")
    setLead("")
    setLeadValue("")
    setSellers("")
  };

  const getQuotes = async () => {
    const limit = 0
    const page = 1

    const baseUrl = `${BACKEND}/api/cotizaciones`;
    
    // Parámetros base para ambas peticiones
    const querySuccessParams = {
      page,
      limit,
      'where[estado][equals]': 'Exito',
    };
    
    const queryPendingParams = {
      page,
      limit,
      'where[estado][equals]': 'En espera'
    };

    // Arrays para los filtros AND
    let andSuccessFilters = [];
    let andPendingFilters = [];
  
    // Filtros de fecha para éxito (fechaVenta)
    if (startDate) {
      andSuccessFilters.push({
        [`fechaVenta`]: {
          greater_than_equal: new Date(startDate).toISOString(),
        }
      });
    }
    if (endDate) {
      andSuccessFilters.push({
        [`fechaVenta`]: {
          less_than_equal: new Date(endDate).toISOString(),
        }
      });
    }
  
    // Filtros de fecha para espera (createdAt)
    if (startDate) {
      andPendingFilters.push({
        [`createdAt`]: {
          greater_than_equal: new Date(startDate).toISOString(),
        }
      });
    }
    if (endDate) {
      andPendingFilters.push({
        [`createdAt`]: {
          less_than_equal: new Date(endDate).toISOString(),
        }
      });
    }

    if (estado) {
      querySuccessParams['where[estado][equals]'] = estado;
      queryPendingParams['where[estado][equals]'] = estado;
    }

    if (subEstado) {
      querySuccessParams['where[subEstado][equals]'] = subEstado;
      queryPendingParams['where[subEstado][equals]'] = subEstado;
    }
  
    // Filtros comunes
    if (vendedor) {
      querySuccessParams['where[cotizador][equals]'] = vendedor;
      queryPendingParams['where[cotizador][equals]'] = vendedor;
    }
  
    if (cliente) {
      querySuccessParams['where[cliente][equals]'] = cliente.id;
      queryPendingParams['where[cliente][equals]'] = cliente.id;
    }

    if (lead) {
      if (leadValue === "dni") {
        querySuccessParams['where[lead.dni][like]'] = lead;
        queryPendingParams['where[lead.dni][like]'] = lead;
      } else if (leadValue === "phone") {
        querySuccessParams['where[lead.phone][like]'] = lead;
        queryPendingParams['where[lead.phone][like]'] = lead;
      } else if (leadValue === "leadName") {
        querySuccessParams['where[lead.leadName][like]'] = lead;
        queryPendingParams['where[lead.leadName][like]'] = lead;
      }
    }

    // Agregamos los filtros AND a los parámetros
    if (andSuccessFilters.length > 0) {
      andSuccessFilters.forEach((filter, index) => {
        const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
        const value = Object.values(Object.values(filter)[0])[0];
        querySuccessParams[key] = value;
      });
    }

    if (andPendingFilters.length > 0) {
      andPendingFilters.forEach((filter, index) => {
        const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
        const value = Object.values(Object.values(filter)[0])[0];
        queryPendingParams[key] = value;
      });
    }

    // Convertimos a query strings
    const querySuccessString = new URLSearchParams(querySuccessParams).toString();
    const queryPendingString = new URLSearchParams(queryPendingParams).toString();

    try {
      setLoading(true)

      // console.log('URL para éxito:', `${baseUrl}?${querySuccessString}`);
      // console.log('URL para espera:', `${baseUrl}?${queryPendingString}`);

      const [responseSuccess, responsePending] = await Promise.all([
        axios.get(`${baseUrl}?${querySuccessString}`),
        axios.get(`${baseUrl}?${queryPendingString}`)
      ]);
  
      setRecord([...responseSuccess.data.docs, ...responsePending.data.docs]);
      
    } catch (e) {
      console.log(e)
      toast.error("Error al cargar los datos: " + e);
    } finally {
      setLoading(false)
    }
  };

  const getSellers = async () => {
    const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`);
    const vendedores = response.data.docs.filter((v) => v.area.toUpperCase() === "COMERCIAL" || v.area.toUpperCase() === "ADMINISTRACION")
    setSellers(vendedores)
  };

  const quotesPerDay = record.reduce((acc, e) => {
    const creationDate = e.fechaVenta ? new Date(e?.fechaVenta) : new Date(e?.createdAt);
    const fecha = creationDate.toLocaleDateString("en-CA");
    const estado = e?.estado || "Desconocido";
    const precio = e?.precioTotal || 0;
  
    if (!acc[fecha]) {
      acc[fecha] = { "Exito": 0, "En espera": 0, "Perdido": 0 };
    }
  
    if (acc[fecha][estado] !== undefined) {
      acc[fecha][estado] += precio;
    }
  
    return acc;
  }, {});
  
  const totalEvents = Object.entries(quotesPerDay).map(([fecha, estados]) => {
    const lines = [];
  
    if (estados["Exito"] > 0) {
      lines.push(`✅ Éxito: ${parseFloat(estados["Exito"]).toFixed(0)}`);
    }
    if (estados["En espera"] > 0) {
      lines.push(`⏳ En espera: ${parseFloat(estados["En espera"]).toFixed(0)}`);
    }
    if (estados["Perdido"] > 0) {
      lines.push(`❌ Perdido: ${parseFloat(estados["Perdido"]).toFixed(0)}`);
    }
  
    return {
      title: lines.join('\n'),
      start: `${fecha}T00:00:00`,
      end: `${fecha}T23:59:59`,
      color: "#eeeeee",
      textColor: "#000000",
      className: "font-semibold text-xs whitespace-pre-line",
      id: `total-${fecha}`,
      order: 0,
    };
  });
  
  const individualEvents = record.map((r) => ({
    id: `${r.id}`,
    title: `${CapitalizeEachWord(r.cliente?.nombreComercial || r.lead?.leadName || r.leadNombre || r.lead?.brandName)} / ${r.cotizador?.name} / ${r.precioTotal}`,
    start: r.estado === "Exito" ? r.fechaVenta ? new Date(r.fechaVenta).toISOString() : new Date(r.createdAt).toISOString() : new Date(r.createdAt).toISOString(),
    allDay: true,
    color: `${GetStatusColor(r.estado, BackgroundColorQuotesStatusHex)}`,
    textColor: `#000000`,
    className: "text-xs",
    order: `${r.estado === "Exito" ? 1 : 2}`,
  }));
  
  const events = [...totalEvents, ...individualEvents];

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (lead === "") {
      getQuotes(); // Solo se ejecuta cuando se reinicia la búsqueda
    }
  }, [lead]);
  
  useEffect(() => {
    getQuotes()
    getSellers()
    getPaises()
    getCurrencyExchange()
  }, [])

  useEffect(() => { 
    getQuotes();
  }, [startDate, endDate, estado, vendedor, cliente, subEstado]);

  useEffect(() => { // Verificar si la pantalla está en movil
    const mediaQuery = window.matchMedia("(max-width: 900px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);
    
  return (
    <div className="flex flex-col h-screen w-full">
      
      {/* Despegable de la cotización */}
      <DrawerCotizacionCalendarioPagosDetails
        open={openDrawer}
        dataDrawer={currentCot}
        onClose={() => setOpenDrawer(false)}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      <FilterSeguimientoClienteDialog
        setClient={setCliente}
        open={openClienteDialog}
        setOpen={setOpenClienteDialog}
      />

      {/* Header */}
      <div className="flex flex-row px-4 py-1 w-full bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between">

          <div className="flex items-center gap-4 py-6">
            <FaCalendarDays className="text-zinc-700 text-2xl" />
            <h2 className="sm:text-2xl xs:text-lg font-bold text-zinc-700">Calendario de cotizaciones</h2>
          </div>

        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] px-4">
          
          <div className="flex flex-row w-full gap-4 items-center justify-start">

            {/* Estado */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label
                htmlFor="estadoServicio"
                className="block text-xs font-medium text-gray-900 "
              >
                Estado
              </label>
              <select
                value={estado}
                onChange={(e) => {setEstado(e.target.value)}}
                id="estadoServicio"
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value={""}> Todos </option>
                <option value={"Exito"}>Exito</option>
                <option value={"Perdido"}>Perdido</option>
                <option value={"En espera"}>En espera</option>
                <option value={"Anulada"}>Anulada</option>
              </select>
            </div>

            {/* Sub estado */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label className="block text-xs font-medium text-gray-900">
                Subestado
              </label>
              <select
                value={subEstado}
                onChange={(e) => {setSubEstado(e.target.value)}}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <>
                <option value={""}> Todos </option>

                {estado === "Exito" && (
                  <option value={"Exito"}>Exito</option>
                )}

                {estado === "En espera" && (
                  <>
                    <option value={"Evaluando opciones"}>Evaluando opciones</option>
                    <option value={"Para el futuro"}>Para el futuro</option>
                    <option value={"Frio"}>Frio</option>
                    <option value={"Por confirmar depósito"}>Por confirmar depósito</option>
                  </>
                )}

                {estado === "Perdido" && (
                  <>
                    <option value={"Curioso"}>Curioso</option>
                    <option value={"No responde"}>No responde</option>
                    <option value={"El servicio le parece caro"}>El servicio le parece caro</option>
                    <option value={"Decidió trabajar con otra agencia"}>Decidió trabajar con otra agencia</option>
                    <option value={"Competencia o sospechoso"}>Competencia o sospechoso</option>
                    <option value={"Lead con poco presupuesto"}>Lead con poco presupuesto</option>
                  </>
                )} 
                </>
              </select>
            </div>
            
            {/* Vendedor */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label className="block text-xs font-medium text-gray-900 ">
                Vendedor
              </label>

              <select
                id="vendedor"
                style={{ maxWidth: "200px" }}
                value={vendedor}
                onChange={(e) => {setVendedor(e.target.value)}}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value={""}> Todos</option>
                {sellers.map((e) => (
                  <option value={e.id} key={e.id}>
                    {CapitalizeEachWord(e?.name)} -{" "}
                    {CapitalizeEachWord(e?.puesto)}
                  </option>
                ))}
              </select>
            </div>

            {/* Cliente */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label
                htmlFor="cliente"
                className="block text-xs font-medium text-gray-900 "
              >
                Cliente
              </label>

              <div className=" flex justify-center gap-2 items-center">
                <button
                  type="button"
                  onClick={() => setOpenClienteDialog(true)}
                  style={{ maxWidth: "200px" }}
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] px-2"
                >
                  {cliente ? (
                    <>
                      <span>{cliente.nombreComercial}</span>{" "}
                    </>
                  ) : (
                    "Todos"
                  )}
                </button>
                {cliente && (
                  <button
                    type="button"
                    onClick={() => setCliente(null)}
                    className=" bg-red-600 bg-opacity-10 text-red-600 p-2 rounded-xl"
                  >
                    <MdClose />
                  </button>
                )}
              </div>
            </div>

          </div>

          <Button
            variant="contained"
            onClick={() => resetFilters(true)}
            endIcon={<RestartAltIcon/>}
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              fontFamily: "poppins",
              whiteSpace: "nowrap",
              padding: "6px 16px",  // Reducido para evitar desbordamiento
              minWidth: "140px",     // Evita que el botón se haga demasiado pequeño
              maxWidth: "100%", 
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
          >
            Reiniciar filtros
          </Button>

        </div>
      </div>

      {/* Barra de fechas */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full gap-10">
        <div className="flex w-full justify-end overflow-x-auto"> 

          {/* Busqueda por leads */}    
          <div className="flex flex-row gap-2 items-center justify-end px-4">
          
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate font-semibold">Buscar por lead:</span>
              <select
                value={leadValue}
                onChange={(e) => setLeadValue(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder={`Buscar por lead`}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={lead}
                onChange={(e) => setLead(e.target.value)}
              />
              {lead && (
                <FaTimes
                  onClick={() => setLead("")}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => getQuotes()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div> 

      {/* Metadatos */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full gap-10 py-1 items-center justify-center">
        {loading ? (
          <LoadingScreen />
        ) : (
          <>
            <span className="block text-xs font-medium text-gray-900">
              <span className={`${GetStatusColor("Exito", TextColorQuotesStatus)}`}>
                En éxito: 
              </span>
              {" "}
              S/.
              {" "}
              {totalExito.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2            
              })}
            </span>

            <span className="block text-xs font-medium text-gray-900">
              <span className={`${GetStatusColor("En espera", TextColorQuotesStatus)}`}>
                En espera: 
              </span>
              {" "}
              S/.
              {" "}
              {totalEspera.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2            
              })}
            </span>

            <span className="block text-xs font-medium text-gray-900">
              <span className={`${GetStatusColor("Perdido", TextColorQuotesStatus)}`}>
                Perdidos: 
              </span>
              {" "}
              S/.
              {" "}
              {totalPerdido.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2            
              })}
              
            </span>
          </>
        )}
      </div>     
       
      {/* Calendario */}
      <div className="flex w-full gap-2 mt-4">
        <div className="px-4 flex-1">
          <FullCalendar
            events={events}
            eventOrder={"order,start,-duration,title"}
            height="75vh"
            datesSet={(e) => {
              const viewStartDate = e.view.currentStart;
              const viewEndDate = e.view.currentEnd;
              setStartDate(viewStartDate.toISOString().split('T')[0],)
              setEndDate(viewEndDate.toISOString().split('T')[0], )
            }}
            
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              multiMonthPlugin,
            ]}
            moreLinkText={"Ver todos"}
            locale={"es"}
            headerToolbar={{
              start: isMobile ? "prev,next" : "title",
              center:
                !isMobile &&
                "multiMonthYear,dayGridMonth,listMonth",
              end: isMobile
                ? "multiMonthYear,dayGridMonth,listMonth"
                : "prev,next",
            }}
            buttonText={{
              today: "Hoy",
              month: "Mes",
              year: "Año",
              week: "Semana",
              day: "Día",
              listMonth: "Vista mes",
              listDay: "Vista hoy",
              timeGrid: "Semana",
            }}
            views={{
              timeGridFourDay: {
                type: "timeGrid",
                duration: { days: 4 },
                buttonText: "Semana",
              },
              timeGridWeek: {
                duration: { days: isMobile ? 4 : 7 },
                buttonText: "Semana",
              },
            }}
            initialView={isMobile ? "timeGridWeek" : "dayGridMonth"}
            moreLinkHint={true}
            defaultAllDay
            dayMaxEvents={false}
            eventContent={function (arg) {

              let containerEl = document.createElement("div");
              containerEl.classList = `event-container cursor-pointer transition-all duration-100 hover:bg-gray-100`;

              let contentEl = document.createElement("p");
              contentEl.classList = "event-content overflow-hidden";

              if (arg.event.extendedProps.isUrgent) {
                contentEl.innerHTML = "urgent event";
              } else {
                contentEl.innerHTML = `${arg.event.title}`;
              }

              containerEl.appendChild(contentEl);

              // Add click event listener
              containerEl.addEventListener("click", async function (event) {
                // Check if the clicked element matches the desired element
                if (event.target.classList.contains("event-content")) {
                  //Perform asynchronous logic
                  try {
                    const response = await axios.get(`${BACKEND}/api/cotizaciones/${arg.event.id}`);
                    setCurrentCot(response.data);
                    setOpenDrawer(true)
                  } catch (e) {
                    toast.error("No existe esta cotizacion: " + e)
                  }
                }
              });

              return { domNodes: [containerEl] };
            }}
            eventDidMount={(info) => {
              Tippy(info.el, {
                content: info.event.title,
                placement: 'top',
                theme: 'dark',
                animation: 'scale'
              });
            }}
            initialEvents={[]}
          />

        </div>
      </div>

    </div>
  )
}